/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PaymentErrorDetail {
  amount?: number;
  creditCardId?: number;
  creditCardPaymentId?: number;
  creditCardPaymentType?: string;
  creditCardPaymentTypeId?: number;
  dateCreated?: Date;
  extraData?: string;
  gatewayId?: number;
  gatewayName?: string;
  installments?: number;
  lr?: string;
  paymentResponseMessageId?: number;
  paymentResponseMessageTypeId?: number;
  personId?: number;
  personName?: string;
  subscriberId?: number;
  tid?: string;
  transactionStatusId?: number;
  transactionStatusName?: string;
}
